import { FormattedMessage } from 'react-intl'

import { Typography } from '@gto/ui/typography'

export const NoDealsPlaceholder = () => {
  return (
    <section className="mx-auto my-8 flex max-w-[70%] flex-col gap-16 px-0 sm:max-w-none sm:gap-12 sm:px-4">
      <div className="text-center">
        <Typography
          gutterBottom
          color="primary"
          component="h2"
          variant="h3"
        >
          <FormattedMessage id="home.dealsSection.noDeals.title" />
        </Typography>
        <Typography
          className="font-semibold"
          color="text.primary"
          component="h2"
          variant="h6"
        >
          <FormattedMessage id="home.dealsSection.noDeals.description" />
        </Typography>
      </div>
    </section>
  )
}
